export default __webpack_public_path__ + "static/media/09.aedff5f7.jpg";